import React from "react";
import { CssBaseline } from "@mui/material";
import PhysicalMeasurementsList from "./pages/PhysicalMeasurements/PhysicalMeasurementsList";

function App() {
  return (
    <>
      <CssBaseline />
      <PhysicalMeasurementsList />
    </>
  );
}

export default App;


